import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
export type ListProps = StructuredContentDocumentWithRenderer<{
  ordered?: boolean;
  children: StructuredContentDocument;
}>;
export const List = t0 => {
  const $ = _c(5);
  const {
    props
  } = t0;
  const t1 = props.ordered ? "ol" : "ul";
  let t2;
  if ($[0] !== props.children) {
    t2 = renderStructuredContent(props.children);
    $[0] = props.children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <Box component={t1}>{t2}</Box>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};